// @flow
import { NEWS } from './consts'

export const getTranslatedNews = () => {
  const { CURRENT_LANGUAGE = 'en' } = window
  return NEWS[CURRENT_LANGUAGE]
}
